'use strict';
const MILLISECONDS_PER_DAY = 86400000;
const COOKIE_DEFAULT_PATH = '/';
const MAX_EXPIRATION_DATE_IN_DAYS = 13 * 30; // Thirteen months according to GDPR regulation
import * as CMP from '@edreamsodigeo/frontend-cmp-client';

class OdigeoCookieHelper {
    constructor(name, value = '', daysToExpire) {
        this.name = name;
        this.value = value;
        this.path = COOKIE_DEFAULT_PATH;
        this.expiration = daysToExpire;
    }
    get expiration() {
        return this._expiration;
    }
    set expiration(daysToExpire) {
        daysToExpire = (Number.isInteger(daysToExpire) && daysToExpire <= MAX_EXPIRATION_DATE_IN_DAYS) ? daysToExpire : MAX_EXPIRATION_DATE_IN_DAYS;
        const expirationDate = new Date();
        const expirationTime = expirationDate.getTime() + (daysToExpire * MILLISECONDS_PER_DAY);
        expirationDate.setTime(expirationTime);
        this._expiration = expirationDate.toUTCString();
    }
    toString() {
        const props = [this.name, 'expires', 'path'];
        const values = [this.value, this.expiration, this.path];
        return props.reduce((cookieChunks, prop, i) => {
            const value = values[i];
            if (value !== null) {
                cookieChunks.push(`${prop}=${value}`);
            }
            return cookieChunks;
        }, []).join('; ');
    }
    static fromDocumentCookieString(name, documentCookieString = '') {
        const browserCookies = documentCookieString.split(';');
        const nameEQ = `${name}=`;
        const matchingNameCookie = browserCookies.find((cookie) => cookie.indexOf(nameEQ) !== -1);
        const value = matchingNameCookie ?
            matchingNameCookie.substring(matchingNameCookie.indexOf(nameEQ) + nameEQ.length):
            null;
        return new OdigeoCookieHelper(name, value);
    }
}

Odigeo.Utils.createCookie = (name, value, days) => {
    const cookie = new OdigeoCookieHelper(name, value, days);

    if (CMP.isAllowed('cookies', name)) {
        document.cookie = cookie.toString(); // eslint-disable-line no-restricted-properties
    }
};

Odigeo.Utils.readCookie = (name) => {
    let cookieValue;

    if (CMP.isAllowed('cookies', name)) {
        // eslint-disable-next-line no-restricted-properties
        cookieValue = OdigeoCookieHelper.fromDocumentCookieString(name, document.cookie).value;
    }
    return cookieValue || null;
};

Odigeo.Utils.eraseCookie = (name) => {
    const cookie = new OdigeoCookieHelper(name, '', -1);
    document.cookie = cookie.toString(); // eslint-disable-line no-restricted-properties
};

